// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
    background: #000;
    display: flex;
    flex-direction: column;
    padding: 12px var(--card-padding) 5px var(--card-padding);
    align-items: center;
    font-size: 14px;
    opacity: 0.8;
}
/* 
footer a.footer-logo {
    display: flex;
} */

footer a.footer-logo {
    height: 36px;
    width: auto;
    display: flex;
    padding: 0 5px 5px 5px;
}
.footer-small-print {
    display: flex;
    align-items: center;
    flex-direction: column;
    color: #fff;
}
footer ul {
    display: flex;
    list-style-type: none;
    padding-left: 0;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}
footer li {
    padding: 0;
    display: flex;
    align-items: center;
    margin-right: 5px;
}
footer a,
footer a:link,
footer a:visited,
footer a:hover {
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    font-size: 14px;
}
footer li a {
    height: var(--min_touch_target);
    padding-right: 5px;
    display: flex;
    align-items: center;
}
footer li:after {
    content: "";
    height: 12px;
    width: 1px;
    background: var(--ce-grey-30);
}
footer li:last-of-type {
    margin-right: 0;
}
footer li:last-of-type a {
    padding-right: 0;
}
footer li:last-of-type:after {
    height: 0;
    width: 0;
}

@media (min-width: 576px) {
    footer {
        background: #000;
        flex-direction: row;
        display: flex;
        justify-content: space-between;
        padding: 12px var(--card-padding) 5px var(--card-padding);
    }
    .footer-small-print {
        align-items: flex-end;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Coordinator/Footer.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,yDAAyD;IACzD,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;AACA;;;GAGG;;AAEH;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;AACA;;;;IAII,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,eAAe;AACnB;AACA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,6BAA6B;AACjC;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;QACb,8BAA8B;QAC9B,yDAAyD;IAC7D;IACA;QACI,qBAAqB;IACzB;AACJ","sourcesContent":["footer {\n    background: #000;\n    display: flex;\n    flex-direction: column;\n    padding: 12px var(--card-padding) 5px var(--card-padding);\n    align-items: center;\n    font-size: 14px;\n    opacity: 0.8;\n}\n/* \nfooter a.footer-logo {\n    display: flex;\n} */\n\nfooter a.footer-logo {\n    height: 36px;\n    width: auto;\n    display: flex;\n    padding: 0 5px 5px 5px;\n}\n.footer-small-print {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    color: #fff;\n}\nfooter ul {\n    display: flex;\n    list-style-type: none;\n    padding-left: 0;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n}\nfooter li {\n    padding: 0;\n    display: flex;\n    align-items: center;\n    margin-right: 5px;\n}\nfooter a,\nfooter a:link,\nfooter a:visited,\nfooter a:hover {\n    color: #fff;\n    text-decoration: none;\n    cursor: pointer;\n    font-size: 14px;\n}\nfooter li a {\n    height: var(--min_touch_target);\n    padding-right: 5px;\n    display: flex;\n    align-items: center;\n}\nfooter li:after {\n    content: \"\";\n    height: 12px;\n    width: 1px;\n    background: var(--ce-grey-30);\n}\nfooter li:last-of-type {\n    margin-right: 0;\n}\nfooter li:last-of-type a {\n    padding-right: 0;\n}\nfooter li:last-of-type:after {\n    height: 0;\n    width: 0;\n}\n\n@media (min-width: 576px) {\n    footer {\n        background: #000;\n        flex-direction: row;\n        display: flex;\n        justify-content: space-between;\n        padding: 12px var(--card-padding) 5px var(--card-padding);\n    }\n    .footer-small-print {\n        align-items: flex-end;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
